import React from "react";
import AppLink from "./app-link";
import Foundation from "./foundation";

const Corrections = () => (
  <Foundation>
    Report corrections to{" "}
    <AppLink href="mailto:Admin_CP-CTNet@frontierscience.org">
      Admin_CP-CTNet@frontierscience.org
    </AppLink>
  </Foundation>
);

export default Corrections;
